import { Progress } from "antd";

const getColor = (value: any) => {
  const color = ["#33C375 ", "#33C38E", "#F0B34B", "#F08B4C", "#F46A6A"];
  if (value <= 20) return color[4];
  if (value > 20 && value <= 40) return color[3];
  if (value > 40 && value <= 60) return color[2];
  if (value > 60 && value <= 80) return color[1];
  if (value > 80) return color[0];
};

interface ProgressComponentProps {
  type: "circle" | "line" | "dashboard" | undefined;
  percentage: number;
  width?: number;
  showInfo?: boolean;
}

function ProgressComponent(props: ProgressComponentProps) {
  const { type, percentage, width, showInfo } = props;
  return (
    <div style={{ display: "flex", flex: 1 }}>
      <Progress
        type={type}
        showInfo={showInfo}
        strokeColor={getColor(percentage)}
        strokeWidth={10}
        status="normal"
        strokeLinecap="round"
        trailColor="#b4bbc14d"
        percent={percentage}
        width={width}
      />
    </div>
  );
}

ProgressComponent.defaultProps = {
  width: 25,
  showInfo: false,
};

export default ProgressComponent;
